query inboxForecastTeamLookup($groupId: String!) {
  getGroup(groupId: $groupId) {
    id
    name
    type
    typeDisplay
    parentGroups {
      id
      name
    }
  }
}
